import { render, staticRenderFns } from "./SelectFilter.vue?vue&type=template&id=baa6ffd0&lang=pug"
import script from "./SelectFilter.vue?vue&type=script&lang=js"
export * from "./SelectFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports